__turbopack_context__.v({
  "jobSummaryStep": "G4z1La_jobSummaryStep",
  "jobSummaryStep__billingGrid": "G4z1La_jobSummaryStep__billingGrid",
  "jobSummaryStep__clientTabs": "G4z1La_jobSummaryStep__clientTabs",
  "jobSummaryStep__datesGrid": "G4z1La_jobSummaryStep__datesGrid",
  "jobSummaryStep__error": "G4z1La_jobSummaryStep__error",
  "jobSummaryStep__footer": "G4z1La_jobSummaryStep__footer",
  "jobSummaryStep__header": "G4z1La_jobSummaryStep__header",
  "jobSummaryStep__identityGrid": "G4z1La_jobSummaryStep__identityGrid",
  "jobSummaryStep__kindTabs": "G4z1La_jobSummaryStep__kindTabs",
  "jobSummaryStep__panel": "G4z1La_jobSummaryStep__panel",
  "jobSummaryStep__sectionDescription": "G4z1La_jobSummaryStep__sectionDescription",
  "jobSummaryStep__sectionTitle": "G4z1La_jobSummaryStep__sectionTitle",
  "jobSummaryStep__subtitle": "G4z1La_jobSummaryStep__subtitle",
  "jobSummaryStep__tabsLabel": "G4z1La_jobSummaryStep__tabsLabel",
  "jobSummaryStep__title": "G4z1La_jobSummaryStep__title",
});
